import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Comment from '../Comment';
import * as CommentsSelectors from '../../selectors/comments';

const Replies = ({ repliesIds, isRevisionRequest }) => {
    if (!repliesIds) { return null; }

    return (
        <ol>
            {repliesIds.map((replyId, index) => (
                <li key={index}><Comment commentId={replyId} isReply={true} isRevisionRequest={isRevisionRequest}/></li>
            ))}
        </ol>
    );
};

const mapStateToProps = (state, { commentId }) => ({
    repliesIds: CommentsSelectors.getRepliesIdsByCommentId(state, commentId)
});

Replies.defaultProps = {
    repliesIds: [],
    isRevisionRequest: false
};

Replies.propTypes = {
    repliesIds: PropTypes.array,
    isRevisionRequest: PropTypes.bool
};

export default connect(mapStateToProps)(Replies);
